import React from "react";

function VendasTurnoPDV({ reportData }) {
  reportData.forEach((pdv) => {
    pdv.totais = pdv.vendas.reduce(
      (acc, produto) => {
        acc.total += produto.TOTAL ?? 0;
        acc.qtde += produto.QTDE ?? 0;
        acc.comissao += produto.COMISSAO ?? 0;

        return acc;
      },
      { total: 0, qtde: 0, comissao: 0 }
    );
  });

  return (
    <div className="flex box-border flex-col p-4 gap-12 justify-center items-center w-full">
      {reportData.map((pdv) => (
        <div className="flex box-border flex-col rounded-lg shadow-lg mt-2 p-4 gap-4 justify-center items-center w-full">
          <div className="flex flex-col gap-4 justify-start w-full w-full text-center">
            <h2 className="font-Oswald ">{pdv?.CODPDV}</h2>
            Turno: {pdv?.TURNO} {" | "}
            Responsável: {pdv?.RESPONSAVEL} {" | "}
            Abertura:{" "}
            {pdv?.ABERTURA
              ? new Date(pdv?.ABERTURA).toLocaleDateString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  timeZone: "UTC",
                })
              : null}{" "}
            {" | "}
            Fechamento:{" "}
            {pdv?.FECHAMENTO
              ? new Date(pdv?.FECHAMENTO).toLocaleDateString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  timeZone: "UTC",
                })
              : null}
          </div>

          <div className="box-border overflow-x-auto w-full">
            <table className="min-w-full bg-white border border-solid border-gray-300">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
                    Produto
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Quantidade
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Comissão
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {pdv.vendas.map((row, index) => (
                  <tr
                    key={row?.DESCRICAO + index}
                    className="hover:bg-gray-200"
                  >
                    <td className="font-Roboto px-4 py-2 border-b text-sm">
                      {row.CODPROD} - {row.DESCRICAO}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {row.QTDE}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.COMISSAO).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-300">
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600]">
                    Total
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {pdv.totais.qtde}
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {" "}
                    {pdv.totais?.comissao?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {pdv.totais?.total?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VendasTurnoPDV;
